import React from 'react';
import { Container } from 'react-bootstrap';
import packageJson from '../../package.json';

function Footer({ version = packageJson.version }) {
  return (
    <footer className="footer mt-auto py-3 bg-light border-top text-center text-muted" style={{ fontSize: '0.85rem' }}>
      <Container>
        <div>
          <span>Tribunal Regional Eleitoral de Santa Catarina</span>
        </div>
        <div className="mt-1" style={{ fontSize: '0.8rem' }}>
          <span>Versão {version}</span>
        </div>
      </Container>
    </footer>
  );
}

export default Footer;
